export default function DontHaveAnAccount() {
  return (
    <div>
      <span>Don&apos;t have an account?</span>{' '}
      <a href="/signup">
        <strong>Get started for free.</strong>
      </a>
    </div>
  );
}
